/**
 * EVSA · Corazón de favoritos en productos que se cargan después de la página.
 *
 * La app Wishlist Hero solo pinta el corazón de los productos que ya están en la
 * página cuando ella carga. Los productos que se insertan más tarde (Puedes
 * combinarlo con, Productos relacionados, También te puede interesar en el
 * carrito) se quedaban sin corazón. Este script los detecta cuando aparecen y le
 * pide a la app que los active usando su evento oficial.
 */
(function () {
  var EVENT_NAME = 'wishlist-hero-add-to-custom-element';
  var SELECTOR = '.wishlist-hero-custom-button';
  var RETRY_DELAYS = [400, 1200, 2800];

  function activate(button, attempt) {
    if (!button.isConnected || button.children.length) return;
    document.dispatchEvent(new CustomEvent(EVENT_NAME, { detail: button }));
    if (attempt < RETRY_DELAYS.length) {
      window.setTimeout(function () {
        activate(button, attempt + 1);
      }, RETRY_DELAYS[attempt]);
    }
  }

  function scan(root) {
    var buttons = [];
    if (root.matches && root.matches(SELECTOR)) buttons.push(root);
    if (root.querySelectorAll) {
      Array.prototype.push.apply(buttons, root.querySelectorAll(SELECTOR));
    }
    buttons.forEach(function (button) {
      window.setTimeout(function () {
        activate(button, 0);
      }, RETRY_DELAYS[0]);
    });
  }

  function init() {
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType === 1) scan(node);
        });
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });
    window.setTimeout(function () {
      scan(document);
    }, 2500);
  }

  if (document.body) {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }
})();
